<button mat-raised-button (click)="args.settings.click!(undefined, undefined)">
  {{ args.settings.caption }}
</button>
